import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class AppMainService {
    private loadingIndex: Array<string> = [];
    public showSpinner: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    isShowSpinner(context: string = '') {
        const index: number = this.loadingIndex.findIndex((_context) => _context === context)
        if(context !== '' && index === -1) {
            this.loadingIndex.push(context);
        }

        this.showSpinner.next(true);
    }

    isHideSpinner(context: string = '') {
        const index: number = this.loadingIndex.findIndex((_context) => _context === context)
        if(index !== -1) {
            this.loadingIndex.splice(index, 1);
        }

        if(this.loadingIndex.length === 0) {
            this.showSpinner.next(false);
        }
    }

    hideAllSpinner(){
        this.loadingIndex = [];
        this.showSpinner.next(false);
    }


}
